
import Footer from '../../components/feature/Footer';
import Header from '../../components/feature/Header';
import ScheduleMTSection from './components/ScheduleMTSection';




function ScheduleMT() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <ScheduleMTSection />
      </main>
      <Footer />
    </div>
  );
}

export default ScheduleMT;
